import React, { useEffect, useMemo, useRef } from 'react';
import { MeetingRoomScheduleList } from "./MeetingRoomScheduleList";
import { NoMeetingRoomSelection } from "./NoMeetingRoomSelection";
import styled from "styled-components";
import { isInTeams } from '@shared/utils/TeamsUtils';
import { useDispatch, useSelector } from "react-redux";
import {
  loadAllMeetingRoomsForOffice,
  loadMeetingRoomBookings,
  selectedMeetingRoomCapacityBand,
  selectedMeetingRoomFacilities,
  selectedOffice,
  selectFilteredMeetingRooms
} from "../models/room-finder.duck";
import { tablet } from '@shared/ui/atoms/MediaQueries';
import {
  SyncStatus,
  WithMicrosoftCalendarSyncActiveChecker
} from '@shared/hooks/WithMicrosoftCalendarSyncActiveChecker';
import { HALF_HOUR_TIME_SLOT_HEIGHT } from "./StructuralComponents";

export function RoomFinderView(props: Props) {
  const dispatch = useDispatch();
  const myRef = useRef(null);
  const office = useSelector(selectedOffice);
  const capacityBands = useSelector(selectedMeetingRoomCapacityBand);
  const facilities = useSelector(selectedMeetingRoomFacilities);
  const filteredMeetingRooms = useSelector(selectFilteredMeetingRooms);
  const {calendarSyncStatus} = WithMicrosoftCalendarSyncActiveChecker();


  const containsOutlookMeetingRoom = useMemo(() => {
    if (filteredMeetingRooms) {
      return filteredMeetingRooms.filter(room => !!room.microsoftRoomId).length > 0;
    } else {
      return [];
    }
  }, [filteredMeetingRooms]);

  useEffect(() => {
    if (office) {
      dispatch(loadAllMeetingRoomsForOffice({office: office, capacityBands: capacityBands, facilities: facilities}));
    }
  }, [office, dispatch, capacityBands, facilities]);

  useEffect(() => {
    if (office && filteredMeetingRooms.length > 0) {
      if (!containsOutlookMeetingRoom || calendarSyncStatus === SyncStatus.Active) {
        dispatch(loadMeetingRoomBookings());
      }
    }
  }, [office, filteredMeetingRooms, dispatch, containsOutlookMeetingRoom, calendarSyncStatus]);

  useEffect(() => {
    if (filteredMeetingRooms.length === 0) return;

    try {
      if (myRef) {
        // @ts-ignore
        myRef.current.scrollTop = (HALF_HOUR_TIME_SLOT_HEIGHT * 16) - 10;
      }
    } catch (e) {
    }
  }, [filteredMeetingRooms]);

  return (
    <>
      <Container isInTeams={isInTeams()} className={'roomFinderView__container'} ref={myRef}>
        <MeetingRoomContent>

          <MeetingRoomContentContainer>

            {filteredMeetingRooms.length > 0 ? <MeetingRoomScheduleList calendarSyncStatus={calendarSyncStatus} /> : <>
              <NoMeetingRoomSelection />
            </>}

          </MeetingRoomContentContainer>

        </MeetingRoomContent>
      </Container>
    </>
  )
}

interface Props {
}


const Container = styled.div<any>`
  display: flex;
  max-height: ${props => props.isInTeams ? 'calc(100vh - 60px)' : 'calc(100vh - 244px)'};
  @media (${tablet}) {
    display: flex;
    max-height: ${props => props.isInTeams ? 'calc(100vh - 60px)' : 'calc(100vh - 114px)'};
  }
  margin-right: 4px;
  flex-shrink: 0;
`

const MeetingRoomContent = styled.div`
  width: 100%;
  max-height: inherit;
  height: inherit;
  display: flex;
`

const MeetingRoomContentContainer = styled.div`
  width: 100%;
  max-width: 100%;
  max-height: inherit;
  height: inherit;
`
